import { API_EC } from '@/config/api.config';
import { axiosLite } from '@/config/axios.config';

/**
 * 取得全站商品搜尋建議結果
 */
export const getProductSearchResults = <TResponse>(
    term: string,
    platform: string
) => {
    return axiosLite.get<TResponse[]>(API_EC.PRODUCT_SEARCH, {
        params: {
            term,
            platform,
        },
    });
};
